<template>
  <div class="form-control">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de sección</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las secciónes</option>        
        <option v-for="(seccionDePaginaWeb,index) in seccionesDeLaPaginaWeb" :value="seccionDePaginaWeb.SeccionDeLaPaginaWebId" :key="index">{{seccionDePaginaWeb.NombreDeLaSeccion}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  

  export default {
    data() {
      return {
        enumeraciones,
        idDelModelo:null,
        seccionesDeLaPaginaWeb: []
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    methods: {
       /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 008SeccionesDeLaPaginaWeb
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,this.seccionesDeLaPaginaWeb);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },
      /**
       * Metodo para lenar catalogo 008SeccionesDeLaPaginaWeb mediante el llamado de la API
       */
      cargarSeccionesDePaginaWeb: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SICPO.catalogos.C008SeccionesDeLaPaginaWeb;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};

        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetSeccionesDePaginasWebAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetSeccionesDePaginasWebAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.seccionesDeLaPaginaWeb = respuesta.data.SeccionesDeLaPaginaWeb;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
       // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }

        this.$store.dispatch("A_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb", valoresDelCatalogo);
    },
    created(){
      this.cargarSeccionesDePaginaWeb();
    }
  }
</script>
<style scoped>
.form-control{
    border: .1em solid var(--gris-oscuro-pj);
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C008SeccionesDeLaPaginaWeb.vue